






















































import {Component, Prop, Vue} from 'vue-property-decorator';
import {Accident} from "@/read-model/accident";
import {AccidentsGroup} from "@/read-model/AccidentsGroup";

@Component
export default class AccidentDetails extends Vue {
  @Prop({required: true}) accident!: Accident
  @Prop({required: true}) group!: AccidentsGroup
}
